/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const PresentationChartIcon: React.FC<AllieIconProps> = ({ className, ...props }) => (
  <svg
    {...props}
    className={`stroke-icon ${className}`}
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 27.1667V35.5M20 27.1667L30 35.5M20 27.1667L9.99998 35.5M35 5.5V19.1667C35 21.9669 35 23.3671 34.455 24.4366C33.9756 25.3774 33.2107 26.1423 32.2699 26.6217C31.2004 27.1667 29.8002 27.1667 27 27.1667H13C10.1997 27.1667 8.79959 27.1667 7.73003 26.6217C6.78922 26.1423 6.02431 25.3774 5.54495 24.4366C4.99998 23.3671 4.99998 21.9669 4.99998 19.1667V5.5M13.3333 15.5V20.5M20 12.1667V20.5M26.6666 18.8333V20.5M36.6666 5.5H3.33331"
      stroke="#344054"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
